<template>
  <div class="card">
    <div class="card-header staff-list-header">
      <div class="filters">
        <div class="filter-item">
          <i class="fas fa-search filter-icon"></i>
          <input type="text" v-model="nameFilter" class="form-control form-control-sm" placeholder="名前で検索" />
        </div>
        <div class="filter-item">
          <i class="fas fa-store filter-icon"></i>
          <select v-model="shopFilter" class="form-control form-control-sm">
            <option :value="null">全ての店舗</option>
            <option v-for="shop in shopOptions" :key="shop.id" :value="shop.id">{{ shop.shop_name }}</option>
          </select>
        </div>
        <label class="archive-toggle">
          <input type="checkbox" v-model="showArchived" />
          <span>アーカイブ済みを表示</span>
        </label>
        <button v-if="nameFilter || shopFilter" class="btn btn-sm btn-outline-secondary" @click="clearFilters">
          <i class="fas fa-times mr-1"></i>クリア
        </button>
      </div>
      <button class="btn btn-success" @click="$router.push({name:'CompanyStaffRegisterPage'})">
        <i class="fas fa-plus mr-1"></i>スタッフを登録
      </button>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover staff-table">
          <thead>
            <tr>
              <th class="sortable" style="width:70px;" @click="setSort('id')">
                ID <i :class="sortIcon('id')"></i>
              </th>
              <th class="sortable" @click="setSort('name')">
                名前 <i :class="sortIcon('name')"></i>
              </th>
              <th>所属店舗</th>
              <th class="text-center" style="width:150px;">勤務時間</th>
              <th class="sortable text-center" style="width:100px;" @click="setSort('break_time')">
                休憩 <i :class="sortIcon('break_time')"></i>
              </th>
              <th class="text-center" style="width:100px;">時給</th>
              <th class="text-center" style="width:110px;">日当交通費</th>
              <th class="text-center" style="width:120px;">タイムカード調整</th>
              <th class="text-center" style="width:120px;">タイムカード</th>
              <th class="text-center" style="width:150px;">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="staff in filteredStaff" :key="staff.id" :class="{ 'row-archived': staff.deleted_at }">
              <td class="td-id">{{ staff.id }}</td>
              <td class="td-name">
                {{ staff.name }}
                <span v-if="staff.deleted_at" class="badge-archived">アーカイブ済み</span>
              </td>
              <td class="td-shops">
                <div class="shops-list">
                  <span v-for="shop in (staff.shop || [])" :key="shop.id" class="shop-chip">
                    {{ shop.shop_name }}
                  </span>
                  <span v-if="!staff.shop || staff.shop.length === 0" class="text-muted">未所属</span>
                </div>
              </td>
              <td class="text-center td-hours">
                {{ fmtTime(staff.regular_working_hours_start) }} ~ {{ fmtTime(staff.regular_working_hours_stop) }}
              </td>
              <td class="text-center">{{ staff.break_time != null ? staff.break_time + '分' : '-' }}</td>
              <td class="text-center">{{ yen(staff.hourly_wage) }}</td>
              <td class="text-center">{{ yen(staff.daily_transportation_allowance) }}</td>
              <td class="text-center">
                <span :class="staff.time_adjustment > 0 ? 'badge-on' : 'badge-off'">
                  {{ staff.time_adjustment > 0 ? '行う' : '行わない' }}
                </span>
              </td>
              <td class="text-center">
                <button class="btn btn-sm btn-outline-info btn-timecard" @click="timeCard(staff.id)">
                  <i class="fas fa-clock mr-1"></i>表示
                </button>
              </td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-outline-primary"
                  @click="viewDetails(staff.id)"
                >
                  <i class="fas fa-arrow-right"></i>
                </button>
                <button
                  v-if="staff.deleted_at"
                  class="btn btn-sm btn-outline-success ml-1"
                  @click="confirmRestore(staff)"
                >
                  <i class="fas fa-undo mr-1"></i>復元
                </button>
              </td>
            </tr>
            <tr v-if="filteredStaff.length === 0">
              <td colspan="10" class="text-center text-muted py-4">
                {{ (nameFilter || shopFilter) ? '該当するスタッフがいません' : 'スタッフデータがありません' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modal-restore">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body py-4">
          <p class="mb-3">
            <strong>{{ restoreTarget ? restoreTarget.name : '' }}</strong>
            <span v-if="restoreTarget" class="text-muted">（ID: {{ restoreTarget.id }}）</span>
            のアーカイブを解除します。
          </p>
          <ul class="restore-notes mb-3">
            <li>スタッフとログインアカウントを在籍状態に戻します。</li>
            <li>削除時に外れた所属店舗を戻します。</li>
            <li>退職日はクリアされます。</li>
          </ul>
          <p class="restore-caution mb-0">
            ※ 解除後に<strong>所属店舗</strong>と<strong>ログインできるか</strong>をご確認ください。
            アーカイブ後に会社情報が保存されていると、所属が戻らない場合があります。
          </p>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-outline-secondary" :disabled="restoring" @click="closeRestoreModal">キャンセル</button>
          <button type="button" class="btn btn-success" :disabled="restoring" @click="doRestore">アーカイブを解除する</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal, hideModal } from '../../utils/bsModal'
export default {
  data () {
    return {
      data: [],
      nameFilter: '',
      shopFilter: null,
      showArchived: false,
      sortKey: 'id',
      sortAsc: true,
      // 復元の確認モーダルで表示・実行する対象
      restoreTarget: null,
      // 復元の通信中フラグ。連打すると2発目が 422 を返し、実際は成功しているのに
      // エラートーストが出るため、通信中はボタンを無効にする。
      restoring: false,
    }
  },
  mounted() {
    this.getStaffList();
  },
  computed: {
    shopOptions () {
      const map = new Map();
      this.data.forEach(staff => {
        (staff.shop || []).forEach(shop => {
          if (!map.has(shop.id)) map.set(shop.id, { id: shop.id, shop_name: shop.shop_name });
        });
      });
      return Array.from(map.values()).sort((a, b) => a.shop_name.localeCompare(b.shop_name, 'ja'));
    },
    filteredStaff () {
      let list = this.data.slice();

      if (this.nameFilter) {
        const kw = this.nameFilter.toLowerCase();
        list = list.filter(s => (s.name || '').toLowerCase().includes(kw));
      }
      if (this.shopFilter) {
        list = list.filter(s => (s.shop || []).some(shop => shop.id === this.shopFilter));
      }

      const key = this.sortKey;
      const dir = this.sortAsc ? 1 : -1;
      list.sort((a, b) => {
        let av = a[key];
        let bv = b[key];
        if (key === 'name') {
          return (av || '').localeCompare(bv || '', 'ja') * dir;
        }
        av = av == null ? -Infinity : Number(av);
        bv = bv == null ? -Infinity : Number(bv);
        return (av - bv) * dir;
      });
      return list;
    },
  },
  watch: {
    showArchived () {
      this.getStaffList();
    },
  },
  methods: {
    getStaffList () {
      const company_id = this.$store.getters.company;
      const params = this.showArchived ? { with_trashed: 1 } : {};
      this.$http.get(process.env.VUE_APP_API_PATH + '/company/staffList/'+company_id, { params })
      .then(response => {
        if (response.data.success) {
          this.data = response.data.data;
        }
      })
      .catch(error => {
        this.data = [];
        if (error.response) {
          this.$toast.error(error.response.data.message);
        }
      });
    },
    setSort (key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        this.sortAsc = true;
      }
    },
    sortIcon (key) {
      if (this.sortKey !== key) return 'fas fa-sort sort-icon';
      return this.sortAsc ? 'fas fa-sort-up sort-icon active' : 'fas fa-sort-down sort-icon active';
    },
    clearFilters () {
      this.nameFilter = '';
      this.shopFilter = null;
    },
    fmtTime (t) {
      if (!t) return '--:--';
      return String(t).slice(0, 5);
    },
    // 金額を桁区切り付きで表示する。null / undefined は「—」。0 は「0円」。
    // != null にしているのは、バックエンド未デプロイでキーが undefined のときに
    // NaN円 を描画しないため。
    yen(amount) {
      return amount != null ? Number(amount).toLocaleString() + '円' : '—';
    },
    viewDetails (staff_id) {
      this.$router.push({name:'CompanyStaffDetailsPage', params: {staff_id: staff_id}});
    },
    confirmRestore (staff) {
      this.restoreTarget = staff;
      showModal('modal-restore');
    },
    closeRestoreModal () {
      hideModal('modal-restore');
      this.restoreTarget = null;
    },
    doRestore () {
      const staff = this.restoreTarget;
      if (!staff || this.restoring) {
        return;
      }
      this.restoring = true;
      this.$http.patch(process.env.VUE_APP_API_PATH + '/company/staff/' + staff.id + '/restore')
        .then(response => {
          hideModal('modal-restore');
          this.restoreTarget = null;
          const data = response.data.data || {};
          if (data.restored_affiliations === 0) {
            // 所属行が物理削除されていた場合(会社情報の保存が挟まると起きる)。
            // 黙って未所属で復活すると気づけないので警告を出す。
            this.$toast.warning('アーカイブを解除しましたが、所属店舗は復元されませんでした。店舗を設定し直してください。');
          } else {
            this.$toast.success(response.data.message || 'アーカイブを解除しました');
          }
          this.getStaffList();
        })
        .catch(error => {
          hideModal('modal-restore');
          this.restoreTarget = null;
          this.$toast.error((error.response && error.response.data.message) || 'アーカイブの解除に失敗しました');
        })
        .then(() => {
          this.restoring = false;
        });
    },
    timeCard (staff_id) {
      this.$router.push({name:'CompanyStaffTimeCardPage', params: {staff_id:staff_id}});
    },
  },
};
</script>

<style scoped>
.staff-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  background: #f7fafc;
  flex-wrap: wrap;
}

.filters {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.filter-item {
  position: relative;
  display: flex;
  align-items: center;
}

.filter-icon {
  position: absolute;
  left: 10px;
  color: #a0aec0;
  font-size: 13px;
  pointer-events: none;
}

.filter-item .form-control {
  padding-left: 30px;
}

.filter-item input.form-control {
  width: 200px;
}

.filter-item select.form-control {
  width: 200px;
  height: auto;
  min-height: 34px;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-right: 24px;
  line-height: 1.5;
  font-size: 14px;
  color: #2d3748;
  background-color: #fff;
}

.filter-item select.form-control option {
  color: #2d3748;
}

.archive-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #4a5568;
  cursor: pointer;
  white-space: nowrap;
}

.archive-toggle input {
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.staff-table thead th {
  font-size: 13px;
  font-weight: 700;
  color: #4a5568;
  background: #f7fafc;
  border-bottom: 2px solid #e2e8f0;
  padding: 14px 16px;
  white-space: nowrap;
}

.staff-table thead th.sortable {
  cursor: pointer;
  user-select: none;
}

.staff-table thead th.sortable:hover {
  color: #2b6cb0;
}

.sort-icon {
  font-size: 11px;
  color: #cbd5e0;
  margin-left: 2px;
}

.sort-icon.active {
  color: #2b6cb0;
}

.staff-table tbody td {
  padding: 12px 16px;
  font-size: 15px;
  vertical-align: middle;
  border-color: #edf2f7;
}

.staff-table tbody tr {
  transition: background-color 0.15s ease;
}

.staff-table tbody tr:hover {
  background-color: #f0faf4;
}

.td-id {
  color: #718096;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}

.td-name {
  font-weight: 600;
  color: #1a202c;
  white-space: nowrap;
}

.td-hours {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  color: #4a5568;
}

.td-shops {
  min-width: 160px;
}

.shops-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.shop-chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  background: #ebf8ff;
  border: 1px solid #bee3f8;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #2a4365;
  white-space: nowrap;
}

.btn-timecard {
  white-space: nowrap;
}

.badge-on {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
  background: #c6f6d5;
  color: #22543d;
}

.badge-off {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
  background: #edf2f7;
  color: #718096;
}

.badge-archived {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  background: #fed7d7;
  color: #822727;
  vertical-align: middle;
}

.row-archived {
  background-color: #fffafa;
}

.row-archived .td-id,
.row-archived .td-name,
.row-archived .td-hours {
  color: #a0aec0;
}

.restore-notes {
  padding-left: 20px;
  font-size: 13px;
  color: #4a5568;
}

.restore-notes li {
  margin-bottom: 4px;
}

.restore-caution {
  font-size: 12px;
  color: #822727;
}
</style>
